import { getBlogManifest } from '@/content/blog/loadPosts';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Grid,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { MarketingPageShell } from '@/components/Marketing/MarketingPageShell';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function BlogIndexPage() {
  const { posts } = getBlogManifest();
  usePageMeta(
    'Blog',
    'Articles on mortgages, investor markets, and real estate strategy from Unbeatable Loans.'
  );

  return (
    <MarketingPageShell
      title="Our Latest Articles"
      subtitle="Mortgage savings, market updates, and investor-focused guides."
    >
      <Grid container spacing={3}>
        {posts.map((post) => (
          <Grid item xs={12} md={6} key={post.slug}>
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                borderColor: 'divider',
                borderRadius: 2,
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: 3 },
              }}
            >
              <CardActionArea
                component={Link}
                to={`/post/${post.slug}`}
                sx={{ height: '100%', alignItems: 'stretch' }}
              >
                <CardContent>
                  <Chip
                    label={post.category}
                    size="small"
                    sx={{ mb: 1 }}
                    color="primary"
                    variant="outlined"
                  />
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 700, mb: 1 }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2, lineHeight: 1.6 }}
                  >
                    {post.description}
                  </Typography>
                  <Typography variant="caption" color="text.disabled">
                    {format(new Date(post.publishedAt), 'MMMM d, yyyy')} ·{' '}
                    {post.readTimeMinutes} min read
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4 }}>
        <Typography variant="body2" color="text.secondary">
          More stories coming soon.
        </Typography>
      </Box>
    </MarketingPageShell>
  );
}
